import { jsonMember, jsonObject } from 'typedjson';
import { PublicShippingPriceType } from '../../enums/public-shipping-price-type';
import { DictionaryCountryResponse } from '@web/shared/module/dictionary';
import { Nillable } from '@web/utils';
import { ShippingMethodResponse } from '../../../shared/api/responses';

@jsonObject
export class PublicCartShippingResponse {
  @jsonMember(String)
  public readonly priceType!: PublicShippingPriceType;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(DictionaryCountryResponse)
  public readonly country?: Nillable<DictionaryCountryResponse>;

  @jsonMember(ShippingMethodResponse)
  public readonly method?: Nillable<ShippingMethodResponse>;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(Number)
  public readonly unitPrice!: number;
}
